import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { CustomerService } from "../../../../modules/customer/customer.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DealsService } from "../../../../auth/service/deals.service";
import moment from "moment/moment";
import { CommissionService } from "../../../../auth/service/commission.service";
import { OrdersService } from "../../../../auth/service/orders.service";
import { ICommission } from "../../../../auth/models/commission-interface";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { IdealBE } from "../../../../auth/models/deal-inferface";
import { ListService } from "../../../../auth/service/list.service";
import { ProductsCommissionsService } from "../../../../modules/products/products-commissions.service";
import { ICustomer } from "../../../../modules/customer/customer.interface";

@Component({
  selector: "app-commission-create",
  templateUrl: "./commission-create.component.html",
  styleUrls: ["./commission-create.component.scss"],
})
export class CommissionCreateComponent implements OnInit {
  @ViewChild("detailOrder") detailOrder: ElementRef;
  public contentHeader: IContentHeader;
  public formGroupDetail: FormGroup;
  public formGroupOrder: FormGroup;
  public customersList: ICustomer[] = [];
  public employeesList: any = [];
  public paymentsTermsList: Array<object> = [];
  public billingFrequencyList: Array<object> = [];
  public dealsList: IdealBE[] = [];
  public dealsFilteredList: Array<IdealBE> = [];
  public timeMaterialEffort: number = 0;
  public activeTab: string = "detail";
  public orderList: any = [
    {
      //On create form it will be always one order
      deal_id: null,
      deal_name: null,
      employees_hash: null,
      employees_names: [],
      from: null,
      to: null,
      capacity: null,
      residue: null,
      order_number: null,
      order_date: null,
      description: null,
      oder_description: null,
      payment_terms: null,
      tranche_import: null,
      tranche_number: null,
      billing_frequency: null,
      effort: null,
      daily_rate: null,
      client_approval: false,
      product_commission_id: null,
    },
  ];
  public selectedDeal: any = null;
  public typeDeal: string = null;
  public showErrors: boolean = false;
  public dealId: number = null;
  public timeMaterialEmployee: Array<any> = [];
  public taskEmployee: Array<any> = [];
  public files_list: Array<any> = [];
  public files_list_obj: Array<any> = [];
  public attachments_list: Array<any> = [];
  public attachments_list_obj: Array<any> = [];
  public detachmentTypes: string[] = ["distacco", "delta"];
  public invoiceTypeList: any[] = [];
  public paymentMeasureUnitList: any[] = [];
  private isACreateDetachmentAction: boolean = false;
  private dealFromQueryParam: any = null;
  private firstProposal: boolean = false; //Usiamo per capire se la prima volta che gli si presenta l'offerta dopo viene settata a false
  public productsCommissions: any = [];
  constructor(
    public _utilService: UtilsService,
    public router: Router,
    public _authService: AuthenticationService,
    public _customerService: CustomerService,
    public _formBuilder: FormBuilder,
    public _modalService: NgbModal,
    public _changeDetectorRef: ChangeDetectorRef,
    public _dealService: DealsService,
    public _userService: UserService,
    private _listService: ListService,
    private activatedRoute: ActivatedRoute,
    private _commissionService: CommissionService,
    private _orderService: OrdersService,
    private _productsCommissionsService: ProductsCommissionsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this._utilService.showLoading()
    this.activatedRoute.queryParams.subscribe((params) => {
      this.dealId = Number(params.deal);
      this.isACreateDetachmentAction = params.detachment;
    });
    this.contentHeader = {
      headerTitle: italian.data.MENU.CREATE_COMMISSION,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.COMMISSION",
            isLink: true,
            link: "/dashboard/commission/list",
          },
          {
            name: italian.data.MENU.CREATE_COMMISSION,
            isLink: false,
          },
        ],
      },
    };
    this.formGroupDetail = this._formBuilder.group({
      customer: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      detachment: new FormControl(false),
    });
    this.formGroupOrder = this._formBuilder.group({
      deal_id: new FormControl(null, [Validators.required]),
      order_number: new FormControl(null),
      order_date: new FormControl(null),
      employees_hash: new FormControl(null, [Validators.required]),
      from: new FormControl(null, [Validators.required]),
      to: new FormControl(null, [Validators.required]),
      capacity: new FormControl(null, [Validators.required]),
      residue: new FormControl(null, [Validators.required]),
      invoice_type: new FormControl(null, [Validators.required]),
      payment_measure_unit: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.maxLength(1000)]),
      order_description: new FormControl(null, [Validators.maxLength(1000)]),
      payment_terms: new FormControl(null, [Validators.required]),
      billing_frequency: new FormControl(null, [Validators.required]),
      detachment_type: new FormControl(null),
      tranche_import: new FormControl(null),
      tranche_number: new FormControl(null),
      client_approval: new FormControl(false),
      detailTimeMaterial: new FormControl(null),
      product_commission_id: new FormControl(null),
      order_cig: new FormControl(null, [Validators.maxLength(10)]),
      order_cup: new FormControl(null, [Validators.maxLength(15)]),
    });
  }

  async ngOnInit() {
    if (!this._authService.hasCapability("create_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this._userService.allUserList.length < 1) {
      await this._userService.getAllUsers();
    }

    this.productsCommissions = await this._productsCommissionsService.getCommissions().catch(() => []);

    //List form back-end
    this.dealsList = await this._dealService.getDeals();
    this.dealsList = this.dealsList.reverse();
    //If a deal has a commission is not available, so we take only deals without a commission ID
    this.dealsList = this.dealsList.filter((deals) => !deals.commission.id);
    //Costruisco l'array dei clienti dalle offerte
    if (this.dealsList && this.dealsList.length > 0) {
      for (let deal of this.dealsList) {
        if (deal.client && deal.client.id && deal.client.name) {
          this.customersList.push({ name: deal.client.name, id: deal.client.id, business_name: null, logo: null, vat_number: null, invoice_type_name: null, bank_name: null });
        }
      }
      //Rimozione dei duplicati
      if (this.customersList && this.customersList.length > 0) {
        this.customersList = this.customersList.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id));
      }
    } else {
      //Se non ci sono offerte chiamo i clienti dal back-end per mostrare dei risultati in caso non ci siano offerte
      this.customersList = await this._customerService.getCustomers();
    }
    this.customersList = this.customersList.sort((a, b) => (a.name > b.name ? 1 : -1));
    this.employeesList = this._userService.allUserList.filter((user) => user.type_code !== "ex-employee");
    this.employeesList = this.employeesList.sort((a, b) => (a.lastname > b.lastname ? 1 : -1));
    this.paymentsTermsList = await this._listService.getList("payment_terms");
    this.billingFrequencyList = await this._listService.getList("billing_frequency");
    this.paymentMeasureUnitList = await this._listService.getList("payment_measure_unit");
    this.invoiceTypeList = await this._listService.getList("invoice_document_type").then((invoiceType) => invoiceType.filter((item: any)=> !item.other.credit_note))

    /**If this variable is filled it's mean that the commission create was selected on deals list,
     * so we have already the customer and the deal
     **/
    if (!!this.dealId) {
      this.dealFromQueryParam = await this._dealService.getDeal(this.dealId);
      this.formGroupDetail.patchValue({
        customer: this.dealFromQueryParam.client.id,
        detachment: this.isACreateDetachmentAction,
      });
      this.formGroupOrder.patchValue({
        deal_id: this.dealId,
      });
      this.filterDeals();
      await this.selectDeal();
      await this.modalOpen(this.detailOrder, null);
    }
    this._utilService.hideLoading();
  }

  ///////////////////////////////////////////////////////////////GENERAL FUNCTIONS////////////////////////////////

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroupOrder.controls[field_name].status === "INVALID";
    } else {
      return this.formGroupOrder.controls[field_name].status === "INVALID" && this.formGroupOrder.controls[field_name].touched;
    }
  }

  resetCapacityAndResidue() {
    this.formGroupOrder.patchValue({
      capacity: null,
      residue: null,
    });
  }

  async modalOpen(modalBasic, currentOrder: any) {
    //Control if selected customer has any deals, if there aren't deals we show an error
    if (!this.dealsFilteredList || this.dealsFilteredList.length < 1) {
      await this._utilService.showSWALError({ text: "NO_DEALS_FOR_SELECTED_CUSTOMER" });
      return false;
    }
    if (this.formGroupDetail.value.detachment) {
      this.formGroupOrder.patchValue({
        detachment_type: "distacco",
      });
    }
    this._modalService.open(modalBasic, {
      size: "xl",
      centered: true,
      keyboard: false,
      backdrop: false,
    });
    //If is already present an order, we patch the values for let the user edit these values
    if (!!currentOrder) {
      this.formGroupOrder.patchValue({
        deal_id: currentOrder.deal_id,
        order_number: currentOrder.order_number,
        order_date: currentOrder.order_date,
        employees_hash: currentOrder.employees_hash,
        from: this._utilService.formatDate(currentOrder.from, "YYYY-MM-DD"),
        to: this._utilService.formatDate(currentOrder.to, "YYYY-MM-DD"),
        capacity: currentOrder.capacity,
        residue: currentOrder.residue,
        payment_measure_unit: currentOrder.payment_measure_unit,
        invoice_type: currentOrder.invoice_type,
        description: currentOrder.description,
        order_description: currentOrder.order_description,
        payment_terms: currentOrder.payment_terms,
        billing_frequency: currentOrder.billing_frequency,
        effort: currentOrder.effort,
        daily_rate: currentOrder.daily_rate,
        tranche_import: currentOrder.tranche_import,
        tranche_number: currentOrder.tranche_number,
        client_approval: currentOrder.client_approval,
        detachment_type: this.formGroupDetail.value.detachment ? "distacco" : null,
      });
    }
  }

  takeDate(event: any, field: string) {
    if (field === "from") {
      this.formGroupOrder.patchValue({
        from: event,
      });
    }
    if (field === "to") {
      this.formGroupOrder.patchValue({
        to: event,
      });
    }
    if (field === "order_date") {
      this.formGroupOrder.patchValue({
        order_date: event,
      });
    }
  }

  ///////////////////////////////////////////////////////////////TASK FUNCTIONS////////////////////////////////

  calculateSingleTrancheTaskOnInit(discount: string, line_amount: string): string {
    if (this.formGroupOrder.value.tranche_number) {
      if (!discount) {
        if (!!line_amount) {
          return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(line_amount) / this.formGroupOrder.value.tranche_number);
        } else {
          return "0,00";
        }
      } else {
        if (!!discount) {
          return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(discount) / this.formGroupOrder.value.tranche_number);
        } else {
          return "0,00";
        }
      }
    } else {
      return "0,00";
    }
  }

  calculateCapacityTaskOnInit() {
    this.showErrors = false;
    if (!this.formGroupOrder.value.from || !this.formGroupOrder.value.to) {
      this.showErrors = true;
      return false;
    }
    this.resetCapacityAndResidue();
    //If is present tranche_import and tranche_number we're going to calculate capacity and residue
    if (this.taskEmployee && this.taskEmployee.length > 0) {
      this.taskEmployee.forEach((row) => {
        row.tranche_single_import = this.calculateSingleTrancheTaskOnInit(row.discount, row.line_amount);
        if (!!this.formGroupOrder.value.tranche_number && this.formGroupOrder.value.tranche_number > 0 && !!row.tranche_single_import) {
          let capacity: number = this.formGroupOrder.value.tranche_number * this._utilService.removeDotsFromNumber(row.tranche_single_import);
          const discount: number = row.discount ? this._utilService.removeDotsFromNumber(row.discount) : 0;
          if (discount && discount !== 0) {
            //If there is a discount we're going to calculate discount divide by effort
            //Check if we have to round the value, if is it zero we don't need to round it
            let toDoMathRound: number = discount % (discount / this.formGroupOrder.value.tranche_number);
            row.tranche_single_import = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discount / this.formGroupOrder.value.tranche_number) : discount / this.formGroupOrder.value.tranche_number);
            capacity = this.formGroupOrder.value.tranche_number * this._utilService.removeDotsFromNumber(row.tranche_single_import);
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          } else {
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          }
        }
      });
    }
    //Adding dots to capacity and residue
    if (!!this.formGroupOrder.value.capacity && !!this.formGroupOrder.value.residue) {
      this.formGroupOrder.patchValue({
        capacity: this._utilService.addDotsToNumber(this.formGroupOrder.value.capacity),
        residue: this._utilService.addDotsToNumber(this.formGroupOrder.value.residue),
      });
    }
  }

  manageTaskRow() {
    //Checking that a user has been deleted
    if (this.taskEmployee && this.taskEmployee.length > 0) {
      this.taskEmployee.map((item: any, index: number) => {
        if (item.employee_hash && !this.formGroupOrder.value.employees_hash.includes(item.employee_hash)) {
          //If a user it's been removed we show an alert
          if (this.taskEmployee.length < 2) {
            this.taskEmployee.pop();
          } else {
            this.taskEmployee.splice(index, 1);
            this.taskEmployee = this.taskEmployee.filter((i) => i);
          }
        }
      });
    }
    //Checking that a user has been added
    if (this.formGroupOrder.value.employees_hash && this.formGroupOrder.value.employees_hash.length > 0) {
      this.formGroupOrder.value.employees_hash.map((employee_hash: string, index: number) => {
        const alreadyInDatatable = this.taskEmployee.find((row) => row.employee_hash === employee_hash);
        if (!alreadyInDatatable) {
          const complete_name = this.employeesList.find((emp) => emp.hash === employee_hash)?.complete_name
          if(complete_name) {
            this.taskEmployee.push({
              employee_hash: employee_hash ? employee_hash : null,
              employee_name: complete_name || "",
              tranche_single_import: null,
              months: this.calculateMonthNumber(),
              monthly_import: null
            });
            const employee = this.selectedDeal.deal_document.table.find((row: any) => row.employee_hash === employee_hash);
            if (!!employee && !!employee.monthly_canon) {
              this.taskEmployee[index].monthly_import = employee.discount ? this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(employee.discount) / employee.months_number) : employee.monthly_canon;
              this.taskEmployee[index].tranche_single_import = null; //Calcolo nella funzione calculate Capacity task
              this.taskEmployee[index].discount = employee.discount;
              this.taskEmployee[index].months = employee.months_number;
              this.taskEmployee[index].line_amount = employee.line_amount;
            }
          }
        }
      });
    }
    this.calculateCapacityTaskOnInit();
  }

  calculateMonthNumber(): number {
    const startDate: moment.Moment = moment(this.formGroupOrder.value.from);
    const endDate: moment.Moment = moment(this.formGroupOrder.value.to);
    const months = Math.round(endDate.diff(startDate, "months", true));
    if (!!this.formGroupOrder.value.from && !!this.formGroupOrder.value.to && months > 1) {
      return months
    } else {
      return 1;
    }
  }

  assignMonthNumberTask(): void {
    if (this.taskEmployee && this.taskEmployee.length > 0) {
      this.taskEmployee.map((emp: any) => {
        emp.months = this.calculateMonthNumber();
      });
    }
  }

  calculateCapacityAndTrancheImportSingleAndGeneral(): void {
    if (this.taskEmployee && this.taskEmployee.length > 0) {
      let sumAllTrancheImport: number = 0;
      this.taskEmployee.map((emp: any) => {
        if (!!emp.monthly_import && this.formGroupOrder.value.tranche_number && emp.months) {
          emp.tranche_single_import = this._utilService.addDotsToNumber((emp.months * this._utilService.removeDotsFromNumber(emp.monthly_import)) / this.formGroupOrder.value.tranche_number);
        }
        if (!!emp.tranche_single_import) {
          sumAllTrancheImport += this._utilService.removeDotsFromNumber(emp.tranche_single_import);
        }
      });
      this.formGroupOrder.patchValue({
        tranche_import: this._utilService.addDotsToNumber(sumAllTrancheImport),
        capacity: this._utilService.addDotsToNumber(sumAllTrancheImport * this.formGroupOrder.value.tranche_number),
        residue: this._utilService.addDotsToNumber(sumAllTrancheImport * this.formGroupOrder.value.tranche_number),
      });
    }
  }

  async calculateTrancheNumberAndFrequency() {
    this.showErrors = false;
    if (this.typeDeal === "Task") {
      const startDate: moment.Moment = moment(this.formGroupOrder.value.from).clone();
      const endDate: moment.Moment = moment(this.formGroupOrder.value.to).clone();
      if (this.formGroupOrder.value.from && this.formGroupOrder.value.to) {
        if (startDate > endDate) {
          this.showErrors = true;
          await this._utilService.showSWALError({ text: "ERROR_DATE" });
          return false;
        }
        this.formGroupOrder.patchValue({
          tranche_number: endDate.diff(startDate, "months") < 1 ? 1 : Math.round(endDate.diff(startDate, "months", true)),
        });
        this.assignMonthNumberTask();
        if (!!this.formGroupOrder.value.billing_frequency) {
          const billing: any = this.billingFrequencyList.find((i: any) => i.id === this.formGroupOrder.value.billing_frequency);
          let tranche: any = this.formGroupOrder.value.tranche_number;
          if (!!tranche) {
            this.formGroupOrder.patchValue({
              tranche_number: Math.round(tranche / billing.other.month_value),
            });
            if (this.formGroupOrder.value.tranche_number === 0) {
              this.formGroupOrder.patchValue({
                tranche_number: 1,
              });
            }
          }
        }
      }
      this.calculateCapacityAndTrancheImportSingleAndGeneral();
    }
  }

  ///////////////////////////////////////////////////////////////TIME MATERIAL FUNCTIONS////////////////////////////////

  //Function for calculating the capacity in case is selected Time Material as a deal's type
  calculateCapacityTimeMaterial() {
    this.showErrors = false;
    if (!this.formGroupOrder.value.from || !this.formGroupOrder.value.to) {
      this.showErrors = true;
      return false;
    }
    this.resetCapacityAndResidue();
    //If is present effort and daily_rate we're going to calculate capacity and residue
    if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
      this.timeMaterialEmployee.forEach((row) => {
        if (!!row.effort && row.effort > 0 && !!row.daily_rate) {
          let capacity: number = row.effort * this._utilService.removeDotsFromNumber(row.daily_rate);
          const discount: number = row.discount ? this._utilService.removeDotsFromNumber(row.discount) : 0;
          const lineAmount: number = row.line_amount ? this._utilService.removeDotsFromNumber(row.line_amount) : 0;
          if (discount < lineAmount && discount !== 0) {
            //If there is a discount we're going to calculate discount divide by effort
            //Check if we have to round the value, if is it zero we don't need to round it
            let toDoMathRound: number = discount % (discount / row.effort);
            row.daily_rate = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discount / row.effort) : discount / row.effort);
            capacity = row.effort * this._utilService.removeDotsFromNumber(row.daily_rate);
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          } else {
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          }
        }
      });
    }
    //Adding dots to capacity and residue
    if (!!this.formGroupOrder.value.capacity && !!this.formGroupOrder.value.residue) {
      this.formGroupOrder.patchValue({
        capacity: this._utilService.addDotsToNumber(this.formGroupOrder.value.capacity),
        residue: this._utilService.addDotsToNumber(this.formGroupOrder.value.residue),
      });
    }
  }

  //In case the deal is Time Material we'll have multiple inputs for each employee selected
  manageTimeMaterialRow() {
    //Checking that a user has been deleted
    if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
      this.timeMaterialEmployee.map((item: any, index: number) => {
        if (item.employee_hash && !this.formGroupOrder.value.employees_hash.includes(item.employee_hash)) {
          //If a user it's been removed we show an alert
          if (this.timeMaterialEmployee.length < 2) {
            this.timeMaterialEmployee.pop();
          } else {
            this.timeMaterialEmployee.splice(index, 1);
            this.timeMaterialEmployee = this.timeMaterialEmployee.filter((i) => i);
          }
        }
      });
    }

    //Checking that a user has been added
    if (this.formGroupOrder.value.employees_hash && this.formGroupOrder.value.employees_hash.length > 0) {
      this.formGroupOrder.value.employees_hash.map((employee_hash: string, index: number) => {
        const alreadyInDatatable = this.timeMaterialEmployee.find((row) => row.employee_hash === employee_hash);
        if (!alreadyInDatatable) {
          this.timeMaterialEmployee.push({
            effort: this.timeMaterialEffort,
            employee_hash: employee_hash ? employee_hash : null,
            employee_name: this.employeesList.find((emp) => emp.hash === employee_hash).complete_name,
            daily_rate: null,
          });
          const employeeDailyRate = this.selectedDeal.deal_document.table.find((row) => row.employee_hash === employee_hash);
          if (!!employeeDailyRate && !!employeeDailyRate.daily_rate) {
            this.timeMaterialEmployee[index].daily_rate = employeeDailyRate.daily_rate;
            this.timeMaterialEmployee[index].discount = employeeDailyRate.discount;
            this.timeMaterialEmployee[index].line_amount = employeeDailyRate.line_amount;
          }
        }
      });
    }
    this.calculateCapacityTimeMaterial();
  }

  calculateEffortTimeMaterial() {
    if (this.typeDeal === "Time Material") {
      if (!this.firstProposal) {
        //Qui entra dopo che all'utente è stata già presenta l'offerta di default
        if (this.formGroupOrder.value.from && this.formGroupOrder.value.to && this.typeDeal === "Time Material") {
          let totalEffort: number = 0;
          const availableWorkingDays = this._utilService.themeConfiguration.working_days;
          const startDate: moment.Moment = moment(this.formGroupOrder.value.from);
          const endDate: moment.Moment = moment(this.formGroupOrder.value.to);
          const numberOfDays: number = endDate.diff(startDate, "days");
          if (typeof numberOfDays == "number" && numberOfDays > 0) {
            for (let i: number = 0; i <= numberOfDays; i++) {
              const date: string = startDate.clone().add(i, "days").format("YYYY-MM-DD");
              //If is not saturday or sunday or an italian holiday we add a day
              //availableWorkingDays contains the working days if you change these in the options, maybe the not working days will be different
              if (availableWorkingDays.includes(Number(moment(date).format("d")))) {
                if (!this._utilService.isHoliday(date)) {
                  totalEffort += 1;
                }
              }
            }
            this.timeMaterialEffort = totalEffort;
            //Insert the effort total for each employee
            if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
              this.timeMaterialEmployee.map((emp) => (emp.effort = this.timeMaterialEffort));
            }
          }
        }
      } else {
        //Qui entra la prima volta che vengono presentati i dati dall'offerta infatti poi firstProposal sarà sempre false
        if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0 && this.selectedDeal.deal_document.table && this.selectedDeal.deal_document.table.length > 0) {
          this.timeMaterialEmployee.map((emp) => {
            const findUser = this.selectedDeal.deal_document.table.find((user) => user.employee_hash === emp.employee_hash);
            emp.effort = findUser && findUser.total_effort ? Number(findUser.total_effort) : 0;
          });
        }
      }

      //Here we're going to recalculate the capacity because the effort is changed
      this.calculateCapacityTimeMaterial();
    }
    this.firstProposal = false;
  }

  ///////////////////////////////////////////////////////////////FORMAT MONEY FUNCTIONS////////////////////////////////

  formatMoneyValue(field: any) {
    this.formGroupOrder.patchValue({ [field]: this._utilService.addDotsToNumber(this.formGroupOrder.value[field]) });
    if (field === "capacity") {
      this.formGroupOrder.patchValue({
        //Residue it will always be filled as a capacity value
        residue: this.formGroupOrder.value.capacity,
      });
    }
  }

  formatDailyRate(index: number) {
    this.timeMaterialEmployee[index].daily_rate = this._utilService.addDotsToNumber(this.timeMaterialEmployee[index].daily_rate);
  }

  formatMonthlyImport(index: number) {
    this.taskEmployee[index].monthly_import = this._utilService.addDotsToNumber(this.taskEmployee[index].monthly_import);
    this.calculateCapacityAndTrancheImportSingleAndGeneral();
  }

  //Function for filtering deals of the customer selected in detail commission
  async selectDeal() {
    //Reset employee time material array
    this.timeMaterialEmployee = [];
    this.taskEmployee = [];
    if (!!this.formGroupOrder.value.deal_id) {
      //Reset the values if the deal_id has changed
      this.formGroupOrder.patchValue({
        order_number: null,
        order_date: null,
        employees_hash: null,
        from: null,
        to: null,
        capacity: null,
        residue: null,
        description: null,
        order_description: null,
        payment_terms: null,
        billing_frequency: null,
        effort: null,
        invoice_type: null,
        payment_measure_unit: null,
        daily_rate: null,
        tranche_import: null,
        tranche_number: null,
        client_approval: false,
      });
      this._utilService.showLoading();
      if (!!this.dealFromQueryParam) {
        this.firstProposal = true;
        this.selectedDeal = this.dealFromQueryParam;
        //Also the type we're going to save
        this.typeDeal = this.selectedDeal.deal_type;
        //Here if we have soma values from the deal we're going to put in our formOrder
        this.formGroupOrder.patchValue({
          billing_frequency: this.selectedDeal?.billing_frequency ? this.selectedDeal.billing_frequency : null,
          from: this.selectedDeal?.start_date ? moment(this.selectedDeal?.start_date, "YYYY-MM-DD") : null,
          to: this.selectedDeal?.end_date ? moment(this.selectedDeal?.end_date, "YYYY-MM-DD") : null,
        });
        //Here the same for the employees
        if (this.selectedDeal.employees && this.selectedDeal.employees.length > 0) {
          let employeesHashes: any = [];
          this.selectedDeal.employees.map((emp: any) => {
            if (!!emp.hash) {
              employeesHashes.push(emp.hash);
            }
          });
          this.formGroupOrder.patchValue({
            employees_hash: employeesHashes,
          });
        }
        this._utilService.hideLoading();
        //We call changTypeDeal for resetting some values and calculate effort and add users if they are present in the selected deal
        this.changeTypeDeal();
      } else {
        await this._dealService
          .getDeal(this.formGroupOrder.value.deal_id)
          .then((response: any) => {
            this.selectedDeal = response;
            //Also the type we're going to save
            this.typeDeal = this.selectedDeal.deal_type;
            //Here if we have soma values from the deal we're going to put in our formOrder
            this.formGroupOrder.patchValue({
              billing_frequency: this.selectedDeal?.billing_frequency ? this.selectedDeal.billing_frequency : null,
              from: this.selectedDeal?.start_date ? moment(this.selectedDeal?.start_date, "YYYY-MM-DD") : null,
              to: this.selectedDeal?.end_date ? moment(this.selectedDeal?.end_date, "YYYY-MM-DD") : null,
            });
            //Here the same for the employees
            if (this.selectedDeal.employees && this.selectedDeal.employees.length > 0) {
              let employeesHashes: any = [];
              this.selectedDeal.employees.map((emp: any) => {
                if (!!emp.hash) {
                  employeesHashes.push(emp.hash);
                }
              });
              this.formGroupOrder.patchValue({
                employees_hash: employeesHashes,
              });
            }
            this._utilService.hideLoading();
            //We call changTypeDeal for resetting some values and calculate effort and add users if they are present in the selected deal
            this.changeTypeDeal();
          })
          .catch(() => {
            this._utilService.hideLoading();
            this._utilService.showSWALError({ text: "ERROR_GET_DEAL" });
          });
      }
    }

    const employees_hash = this.formGroupOrder.value.employees_hash.filter((hash: string) => !!this.employeesList.find((emp) => emp.hash === hash))
    this.formGroupOrder.patchValue({
      employees_hash: employees_hash,
    });
  }

  //Function for filtering deals of the customer selected in detail commission
  filterDeals() {
    if (!!this.formGroupDetail.value.customer) {
      this.dealsFilteredList = this.dealsList.filter((d) => d.client.id === this.formGroupDetail.value.customer);
      this.productsCommissions = this.productsCommissions.filter((p) => p.client_id === this.formGroupDetail.value.customer);
    }
  }

  async goToDealsList() {
    await this.router.navigateByUrl("/dashboard/deals/list");
  }

  changeTypeDeal() {
    //Reset values before calculating
    this.timeMaterialEmployee = [];
    this.taskEmployee = [];
    this.formGroupOrder.patchValue({
      tranche_number: null,
      tranche_import: null,
      payment_measure_unit: null,
    });
    //If is time material we're going to calculateTheEffort and we call manageTimeMaterial
    if (this.typeDeal === "Time Material") {
      this.manageTimeMaterialRow();
      this.calculateEffortTimeMaterial();
    } else {
      this.manageTaskRow();
      //Here we suggest capacity only for the first time or when deal_type change
      const defaultPaymentForTask = this.paymentMeasureUnitList.find((el) => el.name.toLowerCase().includes("numero"));
      if (!!defaultPaymentForTask) {
        this.formGroupOrder.patchValue({
          payment_measure_unit: defaultPaymentForTask.id,
        });
      }
      if (!!this.selectedDeal.tranche_number) {
        const discountDeal: number = this._utilService.removeDotsFromNumber(this.selectedDeal?.deal_document?.table[0]?.total_discounted_deal);
        const totalDeal: number = this._utilService.removeDotsFromNumber(this.selectedDeal?.deal_document?.table[0]?.total_deal);
        let importTranche: any;
        if (discountDeal < totalDeal && discountDeal !== 0) {
          //If there is a discount we're going to calculate discount divide by tranche_number
          //Check if we have to round the value, if is it zero we don't need to round it
          let toDoMathRound: number = discountDeal % (discountDeal / this.selectedDeal.tranche_number);
          importTranche = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discountDeal / this.selectedDeal.tranche_number) : discountDeal / this.selectedDeal.tranche_number);
        } else {
          importTranche = this._utilService.addDotsToNumber(totalDeal / this.selectedDeal.tranche_number);
        }
        this.formGroupOrder.patchValue({
          tranche_number: this.selectedDeal.tranche_number,
          tranche_import: importTranche,
        });
        this.calculateCapacityTaskOnInit();
      }
    }
  }

  ///////////////////////////////////////FILES FUNCTIONS////////////////////////////
  async addFileToList(files: any) {
    //Reset variable, it will contain just one file, so if addFileToList is called we're gonna to overwrite the file list
    let updatedList: any[] = [];
    //For all files charged
    for (let file of files) {
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //I add the file to the list that will be uploaded later
      this.files_list.push(file);
      //I add the file to the update list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    // I updated the variable for the page
    this.files_list_obj = updatedList;
  }

  resetFilesList() {
    this.files_list_obj = [];
    this.files_list = [];
  }

  removeFileFromList(index: any) {
    this.files_list_obj = this.files_list_obj.filter((item: any, i: number) => i !== index);
    this.files_list = this.files_list.filter((item: any, i: number) => i !== index);
  }

  //Attachments functions
  async addAttachmentToList(files: any) {
    // I create a variable from the actual list
    let updatedList: any[] = this.attachments_list_obj.filter((item: any) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //If exits in the list I'll remove it
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachments_list.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    //I update the variable for the page
    this.attachments_list_obj = updatedList;
  }

  resetAttachmentsList() {
    this.attachments_list_obj = [];
    this.attachments_list = [];
  }

  removeAttachmentFromList(index: any) {
    this.attachments_list_obj = this.attachments_list_obj.filter((item: any, i: number) => i !== index);
    this.attachments_list = this.attachments_list.filter((item: any, i: number) => i !== index);
  }

  async uploadFiles(order_id: number) {
    // I'll wait for all files to be uploaded
    await Promise.all(
      this.files_list.map((file: File) => {
        return this._orderService.uploadDocument(file, order_id);
      }),
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  async uploadAttachments(order_id: number) {
    // I'll wait for all attachments to be uploaded
    await Promise.all(
      this.attachments_list.map((file: File) => {
        return this._orderService.uploadAttachment(file, order_id);
      }),
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  //Function that permit to edit an order(Create's form will be only one order)
  async createOrder() {
    this._utilService.showLoading();
    if (!this._authService.hasCapability("create_order")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.showErrors = false;
    let timeMaterialUsersError: boolean = false;
    let taskUsersError: boolean = false;
    if (this.formGroupOrder.invalid) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }
    if (this.formGroupDetail.value.detachment && !this.formGroupOrder.value.detachment_type) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_DETACHMENT_TYPE" });
      this.showErrors = true;
      return false;
    }
    //Check date
    if (moment(this.formGroupOrder.value.from) > moment(this.formGroupOrder.value.to)) {
      this._utilService.hideLoading();
      this.showErrors = true;
      await this._utilService.showSWALError({ text: "ERROR_DATE" });
      return false;
    }
    //Check Candidate Start Contract
    if (this.formGroupOrder.value.employees_hash && this.formGroupOrder.value.employees_hash.length > 0) {
      this._utilService.hideLoading();
      let error: number = 0;
      this.formGroupOrder.value.employees_hash.map(async (empHash) => {
        const employee = this.employeesList.find((emp) => emp.hash === empHash);
        if (!!employee.contract_start_date && !!employee.role && employee.role.toLowerCase() === "candidato") {
          if (moment(this.formGroupOrder.value.from) < moment(employee.contract_start_date.split("T")[0])) {
            error += 1;
            let textError = italian.data.ALERT.FUTURE_EMPLOYEE_ERROR_START_MESSAGE_ONE;
            textError += employee.complete_name;
            textError += italian.data.ALERT.FUTURE_EMPLOYEE_ERROR_START_MESSAGE_TWO;
            textError += moment(employee.contract_start_date.split("T")[0]).format("DD/MM//YYYY");
            await this._utilService.showSWALDeleteConfirmation({
              text: textError,
              title: "ALERT_TITLE",
              showCancelButton: false,
              confirmButtonText: "BTN_CLOSE",
              customClass: { confirmButton: "btn btn-warning" },
            });
            return false;
          }
        }
      });
      if (error > 0) {
        this._utilService.hideLoading();
        return false;
      }
    }
    //Check in case task tranche_number and tranche_import
    if (this.typeDeal === "Task") {
      if (!this.formGroupOrder.value.tranche_import || this.formGroupOrder.value.tranche_import == "0" || !this.formGroupOrder.value.tranche_number) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_TRANCHE_TASK" });
        return false;
      }
      if (this.taskEmployee && this.taskEmployee.length > 0) {
        this.taskEmployee.map((emp) => {
          if (!emp.tranche_single_import || emp.tranche_single_import == 0 || !emp.monthly_import || emp.monthly_import === 0) {
            taskUsersError = true;
          }
        });
      }
      //Check in case of Time Material for each employee if they have effort and daily_rate
    } else {
      if (this.timeMaterialEmployee && this.timeMaterialEmployee.length > 0) {
        this.timeMaterialEmployee.map((emp) => {
          if (!emp.effort || emp.effort == 0 || !emp.daily_rate) {
            timeMaterialUsersError = true;
          }
        });
      }
    }
    //If we have an error in the employee array we'll show an error message
    if (timeMaterialUsersError) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_TIME_MATERIAL_EFFORT_OR_DAILY_RATE" });
      return false;
    }
    if (taskUsersError) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_TASK_SINGLE_TRANCHE_IMPORT" });
      return false;
    }
    //Controllo se è stato caricato un file come ordine debbano essere riempiti i campi numero ordine e data ordine
    if (this.files_list && this.files_list.length > 0) {
      if (!this.formGroupOrder.value.order_number || !this.formGroupOrder.value.order_date) {
        await this._utilService.showSWALError({ text: "ERROR_ORDER_DATE_NUMBER_REQUIRED" });
        return false;
      }
    }
    this._modalService.dismissAll();
    this.activeTab = "orders";
    this.orderList = []; //Reset before the push
    this.orderList.push({
      deal_id: this.formGroupOrder.value.deal_id,
      deal_name: this.dealsList.find((d) => d.id === this.formGroupOrder.value.deal_id).name,
      employees_hash: this.formGroupOrder.value.employees_hash,
      employees_names: [],
      from: moment(this.formGroupOrder.value.from).format("YYYY-MM-DD"),
      to: moment(this.formGroupOrder.value.to).format("YYYY-MM-DD[ 23:59:59]"),
      capacity: this.formGroupOrder.value.capacity,
      residue: this.formGroupOrder.value.residue,
      order_number: this.formGroupOrder.value.order_number,
      order_date: !!this.formGroupOrder.value.order_date ? this.formGroupOrder.value.order_date : null,
      description: this.formGroupOrder.value.description,
      order_description: this.formGroupOrder.value.order_description,
      invoice_type: this.formGroupOrder.value.invoice_type,
      payment_measure_unit: this.formGroupOrder.value.payment_measure_unit,
      payment_terms: this.formGroupOrder.value.payment_terms,
      billing_frequency: this.formGroupOrder.value.billing_frequency,
      detail_time_material: this.timeMaterialEmployee,
      detail_task: this.taskEmployee,
      file: this.formGroupOrder.value.file,
      tranche_import: this.formGroupOrder.value.tranche_import,
      tranche_number: this.formGroupOrder.value.tranche_number,
      client_approval: this.formGroupOrder.value.client_approval,
      detachment_type: this.formGroupDetail.value.detachment ? "distacco" : null,
      progressive_id: "#1",
      product_commission_id: this.formGroupOrder.value.product_commission_id,
      order_cig: this.formGroupOrder.value.order_cig,
      order_cup: this.formGroupOrder.value.order_cup,
    });
    //Here we're going to set a string of all users selected by the hash
    if (this.formGroupOrder.value.employees_hash && this.formGroupOrder.value.employees_hash.length > 0) {
      this.formGroupOrder.value.employees_hash.map((emp_hash) => {
        this.orderList[0].employees_names.push(this.employeesList.find((e) => e.hash === emp_hash).complete_name);
      });
      this.orderList[0].employees_names = this.orderList[0].employees_names.join(", ");
    }
    //If the commission is a detachment we're going to add a second round the first is Distacco the second one Delta
    if (this.formGroupDetail.value.detachment) {
      this.orderList.push({
        deal_id: this.formGroupOrder.value.deal_id,
        deal_name: this.dealsList.find((d) => d.id === this.formGroupOrder.value.deal_id).name,
        employees_hash: this.formGroupOrder.value.employees_hash,
        employees_names: this.orderList[0].employees_names,
        from: this.formGroupOrder.value.from,
        to: moment(this.formGroupOrder.value.to).format("YYYY-MM-DD[ 23:59:59]"),
        capacity: this.formGroupOrder.value.capacity,
        residue: this.formGroupOrder.value.residue,
        order_number: this.formGroupOrder.value.order_number,
        order_date: !!this.formGroupOrder.value.order_date ? this.formGroupOrder.value.order_date : null,
        description: this.formGroupOrder.value.description,
        order_description: this.formGroupOrder.value.order_description,
        payment_terms: this.formGroupOrder.value.payment_terms,
        billing_frequency: this.formGroupOrder.value.billing_frequency,
        invoice_type: this.formGroupOrder.value.invoice_type,
        payment_measure_unit: this.formGroupOrder.value.payment_measure_unit,
        detail_time_material: this.timeMaterialEmployee,
        detail_task: this.taskEmployee,
        file: this.formGroupOrder.value.file,
        tranche_import: this.formGroupOrder.value.tranche_import,
        tranche_number: this.formGroupOrder.value.tranche_number,
        client_approval: this.formGroupOrder.value.client_approval,
        detachment_type: "delta",
        progressive_id: "#2",
        product_commission_id: this.formGroupOrder.value.product_commission_id,
        order_cig: this.formGroupOrder.value.order_cig,
        order_cup: this.formGroupOrder.value.order_cup,
      });
    }
    this._utilService.hideLoading();
  }

  async createCommission() {
    if (!this._authService.hasCapability("create_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    let data: ICommission = {
      client_id: this.formGroupDetail.value.customer,
      name: this.formGroupDetail.value.name,
      order: this.orderList,
      detachment: this.formGroupDetail.value.detachment,
    };
    if (!!data.name) {
      data.name = data.name.trim();
    }
    if (!data.name || data.name.length < 1) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_NAME_REQUIRED" });
      return false;
    }

    await this._commissionService
      .addCommission(data)
      .then(async (res: any) => {
        //If there are files or attachments we're gonna the upload with the order_id
        if (res && res.order_id) {
          if (this.files_list && this.files_list.length > 0) {
            this._utilService.hideLoading();
            await this.uploadFiles(res.order_id);
          }
          if (this.attachments_list && this.attachments_list.length > 0) {
            this._utilService.hideLoading();
            await this.uploadAttachments(res.order_id);
          }
        }
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_COMMISSION" });
        if (!!res.commission_id) {
          await this.router.navigateByUrl(`/dashboard/commission/edit/${res.commission_id}`);
        } else {
          await this.router.navigateByUrl(`/dashboard/commission/list`);
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CREATE_COMMISSION" });
      });
  }
}
